import * as React from 'react';
import { FeatureIcon } from '@grandvisionhq/icons';

const getFeatures = Object.keys;
const SolutionsFeatures = (props)=>{
    if (Object.values(props).every((feature)=>!feature.variantHasAttribute
    )) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("ul", {
        className: "product-detail-solutions-features"
    }, getFeatures(props).map((feature)=>{
        var ref;
        return ((ref = props[feature]) === null || ref === void 0 ? void 0 : ref.variantHasAttribute) && /*#__PURE__*/ React.createElement("li", {
            className: "product-detail-solutions-features__feature product-detail-solutions-features__feature--basics",
            key: feature
        }, /*#__PURE__*/ React.createElement(FeatureIcon, {
            name: feature,
            size: 38
        }), props[feature].label);
    }));
};

export { SolutionsFeatures as default };
//# sourceMappingURL=SolutionsFeatures.js.map
